const pbpCustomerSuccess = {
  all: [
    'activate',
    'create',
    'deactivate',
    'destroy',
    'edit',
    'edit_corporate_client_name',
    'reactivate',
    'read',
    'update',
    'upload',
    'view',
    'view_form',
    'export',
    'invite',
    'bulkDriverUpload',
    'freeze',
  ],
  corporation: {
    cannot: ['set_test'],
  },
  driver: {
    cannot: ['read_all_columns'],
  },
  vehicleForm: ['read_vehicle_location', 'read_vehicle_name', 'read_vehicle_type'],
  fundingRequest: ['approve', 'decline'],
  wallet: {
    cannot: ['create'],
  },
};

export default pbpCustomerSuccess;
